module.exports = __webpack_public_path__ + "img/6742bed.png";